import React, { useState, useEffect, useCallback } from 'react';
import { Form } from 'react-bootstrap';
import api from '../../services/api';

// Temporarily defining Domain here. Ideally, this should be in a shared interfaces file.
export interface Domain {
  id: number;
  nome: string;
  parent_id: number | null;
  framework_id: number;
  empresa_id: number;
  indice: string;
  subdomains: Domain[];
}

interface DomainTreeSelectorProps {
    empresaId: number;
    selectedValue: string;
    onValueChange: (value: string) => void;
}

const DomainTreeSelector: React.FC<DomainTreeSelectorProps> = ({ empresaId, selectedValue, onValueChange }) => {
    const [domains, setDomains] = useState<Domain[]>([]);
    const [loading, setLoading] = useState(true);

    const buildTree = (items: any[]): Domain[] => {
        const tree: Domain[] = [];
        const lookup: { [id: number]: Domain } = {};
        items.forEach(item => { lookup[item.id] = { ...item, subdomains: [] }; });
        items.forEach(item => {
            if (item.parent_id && lookup[item.parent_id]) {
                lookup[item.parent_id].subdomains.push(lookup[item.id]);
            } else {
                tree.push(lookup[item.id]);
            }
        });
        Object.values(lookup).forEach(domain => {
            domain.subdomains.sort((a, b) => a.indice.localeCompare(b.indice, undefined, { numeric: true }));
        });
        tree.sort((a, b) => a.indice.localeCompare(b.indice, undefined, { numeric: true }));
        return tree;
    };

    const fetchDomains = useCallback(async () => {
        setLoading(true);
        const result = await api.getDomains(empresaId);
        if (result.success && result.data) {
            setDomains(buildTree(result.data as any[]));
        } else {
            console.error('Erro ao buscar domínios:', result.error);
        }
        setLoading(false);
    }, [empresaId]);

    useEffect(() => {
        fetchDomains();
    }, [fetchDomains]);

    const renderOptions = (domains: Domain[], level = 0) => {
        let options: React.ReactNode[] = [];
        domains.forEach(domain => {
            options.push(
                <option key={domain.id} value={domain.id}>
                    {'\u00A0'.repeat(level * 4)}{domain.indice} - {domain.nome}
                </option>
            );
            if (domain.subdomains && domain.subdomains.length > 0) {
                options = options.concat(renderOptions(domain.subdomains, level + 1));
            }
        });
        return options;
    };

    return (
        <Form.Select value={selectedValue} onChange={(e) => onValueChange(e.target.value)} disabled={loading}>
            <option value="">{loading ? 'Carregando...' : 'Selecione um domínio'}</option>
            {renderOptions(domains)}
        </Form.Select>
    );
};

export default DomainTreeSelector;